import hashedCAPluginsArray from '../constants/hashedCAPluginsArray';
import hashedCAProjectIdsArray from '../constants/hashedCAProjectIdsArray';
import getPluginCountryCode from './getPluginCountryCode';
import getPluginId from './getPluginId';
import sha256 from './sha256';

const isCanadaWebAppHandler = () => {
  // bulk pickup webapp
  const queryParams = new URLSearchParams(window.location.search);
  const isBpOnly = queryParams.get('feature') === 'bulk_pickup';

  // Read country code from `rc-country-cd` attribute or `country_cd` param
  const countryCode = getPluginCountryCode();
  if (countryCode && countryCode.toUpperCase() === 'CA') return true;

  if (isBpOnly) {
    const project_id = queryParams.get('project_id');
    const hashedProjectId = sha256(project_id);

    // bp only web apps will have project_id in params
    const isExistingCaProjectId = hashedCAProjectIdsArray.includes(hashedProjectId);
    return isExistingCaProjectId;
  }

  // Web app loads from web browser
  const pluginId = getPluginId();
  const hashedPluginId = sha256(pluginId);

  // Not all web apps have `rc-country-cd` attribute or `country_cd` param.
  // Check existing hashed plugin ids in this case. (isCountryCodeCA === null)
  const isExistingCaPluginId = hashedCAPluginsArray.includes(hashedPluginId);

  return isExistingCaPluginId;
};

export default isCanadaWebAppHandler;
